module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-battles-bg-cn.ec5066bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-battles-bg-cn.jpg
// module id = 3159
// module chunks = 11